var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import TooltipExplanationContent from "./TooltipExplanationContent";
var TooltipExplanation = function (_a) {
    var title = _a.title, explanation = _a.explanation, learnMoreURL = _a.learnMoreURL, renderContent = _a.renderContent;
    var _b = useState(false), show = _b[0], setShow = _b[1];
    return (_jsx(OverlayTrigger, __assign({ overlay: function (props) { return (_jsx(TooltipExplanationContent, { title: title, explanation: explanation, overlayInjectedProps: props, learnMoreURL: learnMoreURL, setShow: setShow }, void 0)); }, show: show }, { children: function (props) {
            return renderContent(__assign(__assign({}, props), { onMouseOver: function () { return setShow(true); }, onMouseOut: function () { return setShow(false); } }));
        } }), void 0));
};
export default TooltipExplanation;
//# sourceMappingURL=TooltipExplanation.js.map